import React, { useEffect, useState } from 'react'

interface Props {
  strokeWidth?: number
  sqSize?: number
  interval: number
}

export const CircularProgress = ({ strokeWidth = 3, sqSize = 50, interval: slideInterval }: Props) => {
  const [percentage, setPercentage] = useState(0)
  const [time, setTime] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (percentage >= 100) {
        setTime(0)
      } else {
        setTime(time => time + 500)
      }
    }, 500)

    return () => clearInterval(intervalId)
  })

  useEffect(() => {
    setPercentage((time * 100 / slideInterval) + 10)
    // eslint-disable-next-line
  }, [time])

  const radius = (sqSize - strokeWidth) / 2

  const viewBox = `0 0 ${sqSize} ${sqSize}`

  const dashArray = radius * Math.PI * 2

  const dashOffset = dashArray - dashArray * percentage / 100

  return (
    <svg
      width={sqSize}
      height={sqSize}
      viewBox={viewBox}
    >
      <circle
        className='circle-background'
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        style={{
          stroke: '#ddd'
        }}
      />
      <circle
        className='circle-progress'
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
        style={{
          strokeDasharray: dashArray,
          strokeDashoffset: dashOffset,
          stroke: 'white'
        }}
      />
    </svg>
  )
}
